import { useSubscription } from '@apollo/client'
import { useEffect, useState } from 'react'

function useNotification({ gqltag, params }) {
  const [notification, setNotification] = useState({})
  const { data, loading, error } = useSubscription(gqltag, {
    variables: { input: params },
  })
  useEffect(() => {
    if (!loading) {
      console.log(data, 'Recieved in useNotification')
      setNotification(data)
    }
  }, [data])
  if (error) {
    console.log(error, 'Error in useNotification')
  }
  return { notification }
}

export default useNotification
